<div class='panel panel-primary'>
    <div class="panel-body">

        <div class="table-responsive">
            @if (recipes().length) {
                <table class="table">
                    <thead>
                        <tr>
                            <th>Picture</th>
                            <th>Name</th>
                            <th>Stars</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(recipe of filteredRecipes(); track recipe.filename) {
                          <tr app-recipe-row [myRecipe]="recipe"></tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
</div>
